import { ReactComponent as SOUND } from "../../assets/Sound.svg"
import { ReactComponent as CLOSE } from "../../assets/Close.svg"
import { useAccessibility } from "../../context/AccessibilityContext"

type IconButtonType = {
    function: () => void
    classProps?: string
    customColor?: string
    closeButton?: boolean
}

export default function IconButton(props: IconButtonType) {
    const { getCursorPointerClass } = useAccessibility()
    
    return (
        <button
            className={`${props.customColor ?? "bg-secondary"} h-9 w-9 flex items-center p-2 justify-center shadow-lg rounded-full text-accent  ${getCursorPointerClass()} ${
                props.classProps
            }`}
            onClick={props.function}>
            {props.closeButton ? <CLOSE className="w-5 h-5" /> : <SOUND className="w-5 h-5" />}
        </button>
    )
}
